import actionTypes from "../actions/actionTypes";

const initialState = {
  currentStudent: null,
  currentStudentName: "",
  students: [],
  tasks: [],
  loading: false,
  error: null,
  studentPerformance: {},
  pieces: [],
  successMessage: null,
  sessions: [],
  studentTaskStatus: {
    completed: [],
    incompleted: [],
    ongoing: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TEACHER_REQUEST_START: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case actionTypes.TEACHER_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        successMessage: action.data,
      };
    }
    case actionTypes.TEACHER_REQUEST_FAIL: {
      if (typeof action.data !== "string") {
        return {
          ...state,
          loading: false,
          error: "An Error Occured",
        };
      }
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    }
    case actionTypes.ON_TEACHER_SCREEN_NAVIGATION: {
      return {
        ...state,
        studentTaskStatus: {
          completed: [],
          incompleted: [],
          ongoing: [],
        },
        pieces: [],
        studentPerformance: {},
        tasks: [],
      };
    }
    case actionTypes.CLEAR_TEACHER_REDUCER_STATE: {
      return {
        currentStudent: null,
        students: [],
        tasks: [],
        loading: false,
        error: null,
        studentPerformance: {},
        pieces: [],
        successMessage: null,
        studentTaskStatus: {
          completed: [],
          incompleted: [],
          ongoing: [],
        },
        sessions: [],
      };
    }
    case actionTypes.GET_STUDENTS: {
      const updatedStudents = [...action.data];
      return {
        ...state,
        students: updatedStudents,
      };
    }
    case actionTypes.ADD_STUDENT: {
      const updatedStudents = [...state.students];
      updatedStudents.push(action.data);
      return {
        ...state,
        students: updatedStudents,
      };
    }
    case actionTypes.DELETE_STUDENT: {
      console.log("DELETING STUDENT");
      const updatedStudents = state.students.filter(
        (student) => student.studentId !== action.data,
      );
      return {
        ...state,
        students: updatedStudents,
        sessions: [],
        pieces: [],
      };
    }
    // case actionTypes.UPDATE_STUDENT: {
    //   const updatedStudents = state.students.map((student) => {
    //     if (student.emailId === action.emailId) {
    //       return action.newEmailId;
    //     }
    //     return student;
    //   });
    //   return {
    //     ...state,
    //     students: updatedStudents,
    //   };
    // }
    case actionTypes.GET_TASKS: {
      const updatedTasks = [...action.data];
      return {
        ...state,
        tasks: updatedTasks,
      };
    }
    case actionTypes.REMOVE_TASK: {
      const updatedTasks = state.tasks.filter(
        (task) => task.eventId !== action.data,
      );
      return {
        ...state,
        tasks: updatedTasks,
      };
    }
    case actionTypes.GET_STUDENT_PERFORMANCE: {
      const updatedStudentPerformance = { ...action.data };
      return {
        ...state,
        studentPerformance: updatedStudentPerformance,
      };
    }
    case actionTypes.GET_STUDENT_TASK_STATUS: {
      const updatedStudentTaskStatus = action.data;
      return {
        ...state,
        studentTaskStatus: updatedStudentTaskStatus,
      };
    }
    case actionTypes.CLEAR_TEACHER_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    case actionTypes.CLEAR_TEACHER_SUCCESS: {
      return {
        ...state,
        successMessage: null,
      };
    }
    case actionTypes.FETCH_PIECES: {
      const updatedPieces = [...action.data];
      return {
        ...state,
        pieces: updatedPieces,
      };
    }
    case actionTypes.UPDATE_PIECE_STATUS: {
      const updatedPieces = state.pieces.map((piece) => {
        let updatedPiece = {};
        if (piece.pieceId === action.data.pieceId) {
          updatedPiece = {
            ...piece,
            pieceStatus: action.data.newPieceStatus,
          };
          if (action.data.startDateTimeUTC) {
            updatedPiece = {
              ...updatedPiece,
              startDateTimeUTC: action.data.startDateTimeUTC,
            };
          }
          if (action.data.updatedStartDateTimeUTC) {
            updatedPiece = {
              ...updatedPiece,
              startDateTimeUTC: action.data.updatedStartDateTimeUTC,
            };
          }
          if (action.data.endDateTimeUTC) {
            updatedPiece = {
              ...updatedPiece,
              endDateTimeUTC: action.data.endDateTimeUTC,
            };
          }

          return updatedPiece;
        }
        return piece;
      });
      return {
        ...state,
        pieces: updatedPieces,
      };
    }
    case actionTypes.DELETE_PIECE: {
      const updatedPieces = state.pieces.filter(
        (piece) => piece.pieceId !== action.data,
      );
      return {
        ...state,
        pieces: updatedPieces,
      };
    }
    case actionTypes.UPDATE_RATING: {
      const updatedStudents = state.students.map((student) => {
        if (student.studentId === action.data.studentId) {
          // eslint-disable-next-line no-param-reassign
          student.rating = action.data.rating;
        }
        return student;
      });
      return {
        ...state,
        students: updatedStudents,
      };
    }
    case actionTypes.CHANGE_STUDENT_MESSAGE: {
      const updatedStudents = state.students.map((student) => {
        if (student.studentId === action.data.studentId) {
          // eslint-disable-next-line no-param-reassign
          student.studentMessage = action.data.studentMessage;
        }
        return student;
      });
      return {
        ...state,
        students: updatedStudents,
      };
    }
    case actionTypes.FETCH_SESSION: {
      const updatedSessions = action.data;
      return {
        ...state,
        sessions: updatedSessions,
      };
    }
    case actionTypes.CREATE_SESSION: {
      const updatedSessions = [...state.sessions];
      updatedSessions.push(action.data);
      return {
        ...state,
        sessions: updatedSessions,
      };
    }
    case actionTypes.REMOVE_SESSION: {
      const updatedSessions = state.sessions.filter(
        (session) => session.sessionId !== action.data.sessionId,
      );
      return {
        ...state,
        sessions: updatedSessions,
      };
    }
    case actionTypes.SELECT_STUDENT: {
      const updatedStudent = action.data;
      return {
        ...state,
        currentStudent: updatedStudent,
      };
    }
    case actionTypes.SET_CURRENT_STUDENT_REPORT:
      return {
        ...state,
        currentStudent: action.data,
        currentStudentName: action.name,
      };
    default:
      return state;
  }
};

export default reducer;
